// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-actions-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border-radius: 6px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    width: 92%;
    align-items: center;
}

.tags-section {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}


.tag {
    background-color: var(--black-color);
    border-radius: 4px;
    border: 1px solid var(--e5-border);
    transition: all 0.2s ease;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    padding: 0.5rem 1rem;
    span {
        color: var(--white-background);
        font-size: 1rem;
        font-weight: 400;
    }
}


.remove-tag-btn {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: var(--dc2626-color);
    color: white;
    border: none;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: all 0.2s ease;
}

.remove-tag-btn:hover {
    background-color: var(--ef4444-color);
    transform: scale(1.1);
}

.actions-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 4px;
}

.action-btn {
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid transparent;
    text-align: left;
    background: none;
    display: flex;
    justify-content: space-between;
    background: var(--_d7-background);
    color: var(--_6e6e80-background);
}

.documents-btn {
}

.documents-btn:hover {
    background-color: var(--_16c09821-background);
}

.transactions-btn {
    color: var(--_646e8a-color);
}

.transactions-btn:hover {
    background-color: var(--f5-background);
}

.count {
    color: var(--_8a-color);
    font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/components/contacts/LabelActions.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,4DAA4D;IAC5D,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;;AAGA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,kCAAkC;IAClC,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB;QACI,8BAA8B;QAC9B,eAAe;QACf,gBAAgB;IACpB;AACJ;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,iCAAiC;IACjC,gCAAgC;AACpC;;AAEA;AACA;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB","sourcesContent":[".label-actions-container {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 16px;\n    border-radius: 6px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    width: 92%;\n    align-items: center;\n}\n\n.tags-section {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n\n.tag {\n    background-color: var(--black-color);\n    border-radius: 4px;\n    border: 1px solid var(--e5-border);\n    transition: all 0.2s ease;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 1rem;\n    padding: 0.5rem 1rem;\n    span {\n        color: var(--white-background);\n        font-size: 1rem;\n        font-weight: 400;\n    }\n}\n\n\n.remove-tag-btn {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    background-color: var(--dc2626-color);\n    color: white;\n    border: none;\n    font-size: 1rem;\n    font-weight: bold;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    transition: all 0.2s ease;\n}\n\n.remove-tag-btn:hover {\n    background-color: var(--ef4444-color);\n    transform: scale(1.1);\n}\n\n.actions-section {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 4px;\n}\n\n.action-btn {\n    padding: 6px 12px;\n    border-radius: 4px;\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: 1px solid transparent;\n    text-align: left;\n    background: none;\n    display: flex;\n    justify-content: space-between;\n    background: var(--_d7-background);\n    color: var(--_6e6e80-background);\n}\n\n.documents-btn {\n}\n\n.documents-btn:hover {\n    background-color: var(--_16c09821-background);\n}\n\n.transactions-btn {\n    color: var(--_646e8a-color);\n}\n\n.transactions-btn:hover {\n    background-color: var(--f5-background);\n}\n\n.count {\n    color: var(--_8a-color);\n    font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
